module.exports = __webpack_public_path__ + "41c5c1d4125673c9ad981add94f2f057.svg";